import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, SwitchInput } from '../../Form';
import { autorun } from "mobx/lib/mobx";
import FormMultiSelectInput from "../../FormMultiSelectInput";
import CronIntervalInput from "../../CronIntervalInput";
import { dataDelivery as api } from '../../../actions/api';

@inject('dataExportStore', 'stationStore', 'parameterStore', 'reportingTemplateStore')
@observer
class DataExportEdit extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug = `/export/data-export`;
  title = 'Edit Data Export';

  locationKeys = {
    '-1': {},
    '1': {
      'host': 'Host',
      'user_name': 'User Name',
      'user_password': 'User Password',
      'path': 'Path',
      'interval': 'Interval (min)',
    },
    '2': {
      'path': 'Path',
      'interval': 'Interval',
    },
    '3': {
      'path': 'Path ( /data-export )',
    },
  };

  intervalUnits = [
    { name: 'Minute', value: 1 },
    { name: 'Hour', value: 60 },
    { name: 'Day', value: 60 * 24 },
    // {name: 'Month', value: 60 * 24 * 30},
    // {name: 'Year', value: '1'},
  ];

  @observable multiStationOptions = [];
  @observable multiParameterOptions = [];
  @observable selectedIntervalUnit = 1;
  @observable selectedOffsetIntervalUnit = 1;
  @observable dataExport = {
    name: '',
    description: '',
    protocol: '1',
    formatter: '',
    observation_req: '',
    observation_offset: '',
    stations: [],
    parameters: [],
    use_report_template: 0,
    export_location: {
      host: '',
      user_name: '',
      user_password: '',
      path: '',
      interval: '',
    }
  };

  @observable file = null;
  @observable isRunning = false;

  componentWillMount() {
    const { params: { id }, dataExportStore } = this.props;
    const { stationStore, parameterStore } = this.props;

    if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
    if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();

    const dispose = autorun(() => {
      const foundDataExport = dataExportStore.findById(id);
      if (foundDataExport) {
        switch (true) {
          case +foundDataExport.observation_req >= 60 * 24: this.selectedIntervalUnit = 60 * 24; break;
          case +foundDataExport.observation_req >= 60: this.selectedIntervalUnit = 60; break;
          default: this.selectedIntervalUnit = 1; break;
        }

        this.dataExport = foundDataExport.asJson;
        this.populateOptions();
        // foundDataExport.stations && foundDataExport.stations.forEach(id => this.multiStationOptions.find(item => item.id === id).value = true);
        // foundDataExport.parameters && foundDataExport.parameters.forEach(id => this.multiParameterOptions.find(item => item.id === id).value = true);
        dispose && dispose();
      }
    });
  }

  populateOptions = () => {
    const { stationStore, parameterStore } = this.props;
    if (stationStore.items.length === 0 || parameterStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      if (!this.multiStationOptions.length) this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, label: item.name, value: toJS(this.dataExport.stations).indexOf(item.id) > -1, tags: item.tags }));
      if (!this.multiParameterOptions.length) this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, label: item.name, name: item.name, code: item.code, value: toJS(this.dataExport.parameters).indexOf(item.id) > -1 }));
    }
  };

  optionsReducer = options => options.reduce((acc, item) => {
    if (item.value === true) acc.push(item.id);
    return acc;
  }, []);

  @action onChangeObservationReq = e => this.dataExport.observation_req = e.target.value * (+this.selectedIntervalUnit || 1);
  @action onChangeObservationOffset = e => this.dataExport.observation_offset = e.target.value * (+this.selectedOffsetIntervalUnit || 1);
  @action onChangeIntervalUnit = e => {
    if (!e.target.value) this.dataExport.observation_req = 0;
    this.selectedIntervalUnit = e.target.value;
  }
  @action onChangeOffsetIntervalUnit = e => {
    if (!e.target.value) this.dataExport.observation_offset = 0;
    this.selectedOffsetIntervalUnit = e.target.value;
  }
  @action onChangeExport = (e, key) => this.dataExport[key] = e.target.value;
  @action onChangeLocationItem = (e, key) => this.dataExport.export_location[key] = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const { dataExportStore } = this.props;
    const { notify, router } = this.context;

    this.dataExport.stations = this.optionsReducer(this.multiStationOptions);
    this.dataExport.parameters = this.optionsReducer(this.multiParameterOptions);
    dataExportStore.updateItem(this.dataExport)
      .then(res => {
        notify.success(res);
        router.push(this.slug);
      }).catch(err => {
        notify.error(err);
      });
  };

  handleRun = e => {
    e.preventDefault();
    const { notify } = this.context;

    this.isRunning = true;
    api.export.run(this.props.params.id)
      .then(res => {
        this.isRunning = false;
        notify.success(res);
      })
      .catch(err => {
        this.isRunning = false;
        notify.error(err);
      })
  }

  render() {
    const { dataExportStore, stationStore, parameterStore, reportingTemplateStore } = this.props;

    return (
      <Modal title={this.title} slug={this.slug} isSaving={dataExportStore.isSaving || this.isRunning} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput
              label={'Name'}
              value={this.dataExport.name}
              onChange={e => this.onChangeExport(e, 'name')}
            />
            <TextInput
              label={'Description'}
              value={this.dataExport.description}
              onChange={e => this.onChangeExport(e, 'description')}
            />
            <SelectInput
              label={'Protocol'}
              value={this.dataExport.protocol}
              options={dataExportStore.protocolOptions}
              fields={{ label: 'name', value: 'id' }}
              onChange={e => this.onChangeExport(e, 'protocol')}
            />
            {+this.dataExport.use_report_template ?
              <SelectInput label='Report Template' value={this.dataExport.formatter} options={reportingTemplateStore.items} fields={{ label: 'name', value: 'id' }} onChange={e => this.onChangeExport(e, 'formatter')} /> :
              <TextInput
                label={'Data Formatter'}
                value={this.dataExport.formatter} readOnly
              />}
            <div className="formInput">
              <label>Observation From</label>
              <input
                type={'text'}
                value={this.dataExport.observation_req ? this.dataExport.observation_req / (+this.selectedIntervalUnit || 1) : ''}
                onChange={this.onChangeObservationReq}
                style={{ minWidth: '180px', marginRight: '10px' }}
              />
              <select value={this.selectedIntervalUnit} onChange={this.onChangeIntervalUnit} style={{ width: '100px' }}>
                <option value={''}>--</option>
                {this.intervalUnits.map((option, i) => (
                  <option
                    key={`select-intervalUnit-option-${option.name}-${i}`}
                    value={option.value}
                  >
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <FormMultiSelectInput id='station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={item => item.value = !item.value} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} style={{ width: '200px' }} />
            <FormMultiSelectInput id='parameter-multi-select' label='Parameters' options={this.multiParameterOptions} optionClicked={item => item.value = !item.value} isLoading={parameterStore.isLoading} filterOptions={parameterStore.filterParameters} />
            <hr />
            {this.dataExport.protocol && Object.keys(this.locationKeys[this.dataExport.protocol.toString()]).map(key => {
              let InputComponent = key === 'interval' ? CronIntervalInput : TextInput;
              return (
                <InputComponent type={key === 'user_password' ? 'password' : 'text'} value={this.dataExport.export_location && this.dataExport.export_location[key]}
                  label={this.locationKeys[this.dataExport.protocol.toString()][key]} onChange={e => this.onChangeLocationItem(e, key)}
                  key={`daq-processor-location-edit-item-key-${key}`} />
              )
            })}
            <div className="formInput">
              <label>Observation Offset</label>
              <input
                type={'text'}
                value={this.dataExport.observation_offset ? this.dataExport.observation_offset / (+this.selectedOffsetIntervalUnit || 1) : ''}
                onChange={this.onChangeObservationOffset}
                style={{ minWidth: '180px', marginRight: '10px' }}
              />
              <select value={this.selectedOffsetIntervalUnit} onChange={this.onChangeOffsetIntervalUnit} style={{ width: '100px' }}>
                <option value={''}>--</option>
                {this.intervalUnits.map((option, i) => (
                  <option
                    key={`select-intervalUnit-option-${option.name}-${i}`}
                    value={option.value}
                  >
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
            {!!this.dataExport && [1, 2].indexOf(+this.dataExport.protocol) > -1 && <button onClick={this.handleRun}>Run</button>}
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default DataExportEdit;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/DataExport/DataExportEdit.js